import { Expose } from 'class-transformer';

export default class VerifyDocumentError {
  doc_type: string[] = []
  reason: string[] = []
  approved: string[] = []
  @Expose({ name: '_schema' }) schema: string[] = []
}